export let DesignUploadMode = /*#__PURE__*/function (DesignUploadMode) {
  DesignUploadMode["fullDesign"] = "full-design";
  DesignUploadMode["logo"] = "logo";
  DesignUploadMode["box"] = "box";
  return DesignUploadMode;
}({});

//TODO: remove after product settings implementation

export let HazardousMaterial = /*#__PURE__*/function (HazardousMaterial) {
  HazardousMaterial["NONE"] = "none";
  HazardousMaterial["ORMD"] = "ormd";
  HazardousMaterial["LITHIUM"] = "lithium";
  return HazardousMaterial;
}({});